module.exports = __webpack_public_path__ + "static/media/galerija_2017 (11).e2be2419.jpg";